import React from 'react';
import Hero from '../../components/Hero';
import Sustainability from '../../components/Sustainability';
import FutureVision from '../../components/FutureVision';
import MetaverseLab from '../../components/MetaverseLab';
import Perspectives from '../../components/Perspectives';
import Objective from '../../components/Objective';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Sustainability />
      <FutureVision />
      <MetaverseLab />
      <Perspectives />
      <Objective />
    </>
  );
};

export default Home;